import moment from 'moment';
import 'twix';

import { getHTML } from '../calendarRenderLibrary/calendarRender';
import { Request } from 'common/domain/models/request';

const SUN = 7;
const HOLIDAY = 'holiday';

function fromRangeToArray(
  rangeStart,
  rangeEnd,
  status,
  periodId,
  type,
  code,
  iconDays
) {
  const start = moment(rangeStart, 'YYYY-MM-DD').startOf('day');
  const end = moment(rangeEnd, 'YYYY-MM-DD').endOf('day');
  const itr = moment.twix(start, end).iterate('days');

  const range = [];
  while (itr.hasNext()) {
    const day = itr.next();
    const iconDay = isIconDay(day, iconDays);
    const html = getHTML(day, status, iconDay, iconDays, rangeEnd, type, code);
    const backupType = type;

    const startEqual = areEqualDates(new Date(rangeStart), day.toDate());
    const endEqual = areEqualDates(new Date(rangeEnd), day.toDate());

    if (startEqual && backupType !== HOLIDAY) {
      type += ' start-period';
    }

    if (endEqual && backupType !== HOLIDAY) {
      type += ' end-period';
    }

    range.push({
      day: day.toDate(),
      periodId,
      status,
      type,
      code,
      html: {
        classes: type,
        content: html,
      },
    });

    type = backupType;
  }

  return range;
}

function areEqualDates(firstDate, secondDate) {
  firstDate.setHours(0, 0, 0, 0);
  secondDate.setHours(0, 0, 0, 0);
  return firstDate.getTime() === secondDate.getTime();
}

function isIconDay(day, iconDays) {
  return iconDays.some((iconDay) => {
    return iconDay.getTime() === day.toDate().getTime();
  });
}

function returnIconDays(arrayWithEvents) {
  const iconDays = [];

  arrayWithEvents.forEach((event) => {
    if (event.type === Request.TYPES.HOLIDAY) return;

    let iconDay;
    setEventEndDate(event);

    const start = moment(event.startDate, 'YYYY-MM-DD').startOf('day');
    const end = moment(event.endDate, 'YYYY-MM-DD').endOf('day');
    const itr = moment.twix(start, end).iterate('days');

    iconDays.push(moment(event.endDate)._d);

    while (itr.hasNext()) {
      const day = itr.next();
      iconDay = day;

      if (!isWeekDay(day)) break;
    }

    if (iconDay) iconDays.push(iconDay._d);
  });

  return iconDays;
}

function setEventEndDate(event) {
  if (event.endDate || event.date) {
    event.endDate = event.endDate || event.date;
  } else {
    event.endDate = new Date();
    event.forcedEndDate = true;
  }
}

function findPeriodOfDate(date, rangeStart, rangeEnd) {
  const start = moment(rangeStart, 'YYYY-MM-DD').startOf('day');
  const end = moment(rangeEnd, 'YYYY-MM-DD').endOf('day');
  const current = moment(date, 'YYYY-MM-DD').startOf('day');
  const period = moment.twix(start, end);
  return current.twix(current).overlaps(period);
}

function isWeekDay(date) {
  if (date.isoWeekday() !== SUN) {
    return date;
  }
  return false;
}

function formatDate(date) {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

function parseLocalDate(date) {
  if (!date) return null;
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [y, m, d] = date.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * Returns a date in a long format. Only for presentation purposes.
 * Example: Given a 2017-08-08, returns 'Martes 08 agosto 2017'
 *
 * @param {date} date - String or Date object
 * @param {locale} locale - Language, default spanish
 * @returns {String} Returns a formatted string
 */
function formatDateForView(date, lang = 'es') {
  moment.locale(lang);
  let result = moment(date).format('dddd DD MMMM YYYY');
  result = result.charAt(0).toUpperCase() + result.slice(1);
  return result;
}

export {
  fromRangeToArray,
  returnIconDays,
  findPeriodOfDate,
  formatDate,
  isIconDay,
  isWeekDay,
  formatDateForView,
  areEqualDates,
  parseLocalDate,
};



// WEBPACK FOOTER //
// ./client/app/common/utils/dateUtils/date-utils.js